'use strict';

var $ = require('jquery');

function init() {
	var markers = $('.directorMap__marker');
	if (markers.length === 0)
		return;

	var prevMarker, prevInfo;

	markers.on('click', function() {
		var marker = $(this);
		select(marker);
	});
	$('.directorMap__overlay').on('click', function() {
		select(undefined);
	});

	function select(marker) {
		var info = undefined;

		if (marker !== undefined) {
			var index = marker.attr('data-markerindex');

			info = $('.directorMap__info[data-markerindex="' + index + '"]');

			// Select new
			marker.addClass('directorMap__marker--selected');
			info.addClass('directorMap__info--selected');
		}

		// Unselect previous
		if (prevMarker !== undefined) {
			prevMarker.removeClass('directorMap__marker--selected');
			prevInfo.removeClass('directorMap__info--selected');
		}
		prevMarker = marker;
		prevInfo = info;

		// Set class on 'html' based on if anything selected
		$('html').toggleClass('isDirectorSelected', marker !== undefined);
	}
}

module.exports = {
	init: init
}